export default __webpack_public_path__ + "static/media/crown-icon.8182c2f5.svg";